"use client";

import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const pageContainerVariants = cva(
  "mx-auto w-full px-4 sm:px-6 pb-6 sm:pb-8",
  {
    variants: {
      width: {
        default: "max-w-4xl",
        narrow: "max-w-3xl",
        tight: "max-w-2xl",
      },
    },
    defaultVariants: {
      width: "default",
    },
  }
);

type PageContainerProps = React.ComponentProps<"div"> &
  VariantProps<typeof pageContainerVariants>;

function PageContainer({
  className,
  width,
  children,
  ...props
}: PageContainerProps) {
  return (
    <div
      className={cn(pageContainerVariants({ width }), className)}
      {...props}
    >
      {children}
    </div>
  );
}

export { PageContainer, pageContainerVariants };
